import {
  useCartAndDeliveryDatesDataContext,
  useCurrency,
} from '@app/data/clients/cartCheckoutClient';
import {
  monolithItemToAnalyticsItem,
  trackGA4BeginCheckout,
} from '@app/utils/analytics';
import { useEffect, useRef } from 'react';

export const useTrackGA4BeginCheckout = () => {
  const { cart } = useCartAndDeliveryDatesDataContext();
  const currency = useCurrency();

  const hasFiredEvent = useRef<boolean>(false);

  const couponCode = cart?.applied_coupon?.code;
  const value = cart?.summary.total || 0;
  const showTaxSeparately = cart?.summary.show_tax_separately ?? false;

  const items = cart?.items.map((item, index) =>
    monolithItemToAnalyticsItem(item, currency, index, showTaxSeparately)
  );

  useEffect(() => {
    if (items && !hasFiredEvent.current) {
      hasFiredEvent.current = true;
      trackGA4BeginCheckout({ currency, items, value, couponCode });
    }
  }, [value, items, couponCode, currency]);
};
